// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import prepRadioLevelCalculations from './prepRadioLevelCalculations'
import prepModulationsCalculations from './prepModulationsCalculations'

// make all path calculations based on the given data.
const pathCalculationsForForm = (pathEnd, radio, p2) => {
  const {
    atpc,
    segmentEndCalculations,
    siteName,
  } = pathEnd

  const {
    rslEirpMessage,
  } = segmentEndCalculations

  const radioLevelCalculations = prepRadioLevelCalculations(segmentEndCalculations.radioLevelCalculations, radio)
  const modulationsCalculations = prepModulationsCalculations(pathEnd)

  return {
    siteName,
    atpcEnabled: !!atpc,
    rslEirpMessage,
    modulationsCalculations,
    radioLevelCalculations,
  }
}

export default pathCalculationsForForm
